import { Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

import { DeviceReadonlyStateProvider } from '@shure/shared/angular/utils/device-readonly';

import { AppUpdateService } from './app-update.service';

@Injectable({ providedIn: 'root' })
export class AppUpdateBasedReadonlyStateProvider extends DeviceReadonlyStateProvider {
	private readonly readonly$ = toObservable(this.appUpdateService.isReadOnly);

	constructor(private readonly appUpdateService: AppUpdateService) {
		super();
	}

	public isReadonly$(_deviceId: string): Observable<boolean> {
		return this.readonly$;
	}
}
